/**
 * PROTOTYPE CONTENT — NOT VERIFIED.
 *
 * Restored verbatim from `design-reference/`. These contracts, values, quantities
 * and client organisations were invented to demonstrate the layout. Midvaal Local
 * Municipality, Ridgeway Logistics, Verdant Property Developments and Emfuleni
 * Social Housing Institution are named here without any relationship or consent.
 *
 * Naming a real client is the single highest-risk item on this site. Nothing here
 * may go public without a signed contract behind it and the client's written
 * agreement to the reference. See CONTENT-STATUS.md.
 */
export interface Project {
  slug: string
  title: string
  sector: string
  province: string
  value: string
  status: string
  year: string
  client: string
  /** Caption shown over the image frame. */
  photo: string
  /** Photograph filling the frame. Credits in public/images/CREDITS.json. */
  image: string
  dur: string
  role: string
  scope: string
  /** `[label, value]` pairs. */
  facts: [string, string][]
}

export const projects: Project[] = [
  {
    slug: 'kyalami-yard',
    title: 'Kyalami Ridge Industrial Yard',
    sector: 'Industrial',
    province: 'Gauteng',
    value: 'R11.8 m',
    status: 'On site',
    year: '2026',
    client: 'Ridgeway Logistics (Pty) Ltd',
    photo: 'hardstanding pour',
    image: '/images/project-kyalami-yard.jpg',
    dur: '7 months',
    role: 'Principal contractor',
    scope: '18 000 m² of heavy-duty hardstanding, stormwater attenuation and a reinforced concrete weighbridge platform for a distribution yard in Kyalami.',
    facts: [
      ['Hardstanding', '18 000 m²'],
      ['Stormwater', '1.2 km'],
      ['Peak crew', '34'],
      ['Programme', '7 months'],
    ],
  },
  {
    slug: 'erf-1140-centurion',
    title: 'Erf 1140 Centurion Bulk Earthworks',
    sector: 'Roads & Earthworks',
    province: 'Gauteng',
    value: 'R8.6 m',
    status: 'On site',
    year: '2026',
    client: 'Verdant Property Developments',
    photo: 'cut and fill',
    image: '/images/project-erf-1140-centurion.jpg',
    dur: '5 months',
    role: 'Earthworks contractor',
    scope: 'Bulk cut-to-fill of 96 000 m³, terrace formation and internal access roads for a 22-unit light industrial park. Our first signed contract.',
    facts: [
      ['Material moved', '96 000 m³'],
      ['Terraces', '4'],
      ['Access road', '900 m'],
      ['Programme', '5 months'],
    ],
  },
  {
    slug: 'emalahleni-access-road',
    title: 'Emalahleni Mine Access Road Rehabilitation',
    sector: 'Mining',
    province: 'Mpumalanga',
    value: 'R11.4 m',
    status: 'Awarded',
    year: '2026–2027',
    client: 'Confidential — coal producer',
    photo: 'haul road grading',
    image: '/images/project-emalahleni-access-road.jpg',
    dur: '9 months',
    role: 'Civils contractor',
    scope: '6.2 km of mine access road rebuilt to 40 t axle loading, with new culverts, side drainage and dust suppression, executed alongside live haulage.',
    facts: [
      ['Road length', '6.2 km'],
      ['Design load', '40 t axle'],
      ['Culverts', '14'],
      ['Site handover', 'Oct 2026'],
    ],
  },
  {
    slug: 'midvaal-pipeline',
    title: 'Midvaal Reservoir Pipeline Extension',
    sector: 'Water',
    province: 'Gauteng',
    value: 'R6.9 m',
    status: 'On site',
    year: '2026',
    client: 'Midvaal Local Municipality',
    photo: 'pipe laying',
    image: '/images/project-midvaal-pipeline.jpg',
    dur: '6 months',
    role: 'Principal contractor',
    scope: '3.4 km of 400 mm bulk main, two valve chambers and a pressure-reducing station connecting a new reservoir into the existing network.',
    facts: [
      ['Pipeline', '3.4 km'],
      ['Diameter', '400 mm'],
      ['Chambers', '2'],
      ['Households served', '5 400'],
    ],
  },
  {
    slug: 'rustenburg-terrace',
    title: 'Rustenburg Plant Terrace & Sump Civils',
    sector: 'Mining',
    province: 'North West',
    value: 'R9.3 m',
    status: 'Awarded',
    year: '2026–2027',
    client: 'Confidential — PGM producer',
    photo: 'plant terrace',
    image: '/images/project-rustenburg-terrace.jpg',
    dur: '8 months',
    role: 'Civils contractor',
    scope: 'Terrace platform, concrete plinths, a pollution control sump and cable trenching for a plant expansion on a live PGM operation.',
    facts: [
      ['Platform', '2.4 ha'],
      ['Concrete', '3 100 m³'],
      ['Sump capacity', '4 200 m³'],
      ['Site handover', 'Nov 2026'],
    ],
  },
  {
    slug: 'vereeniging-housing',
    title: 'Vereeniging Social Housing Phase 1 Sitework',
    sector: 'Real Estate',
    province: 'Gauteng',
    value: 'R12.8 m',
    status: 'Tendering',
    year: '2027',
    client: 'Emfuleni Social Housing Institution',
    photo: 'site clearance',
    image: '/images/project-vereeniging-housing.jpg',
    dur: '10 months',
    role: 'Sitework contractor',
    scope: 'Site clearance, bulk services, internal roads and platform preparation enabling 180 rental units. Tender submitted August 2026; award expected November.',
    facts: [
      ['Units enabled', '180'],
      ['Internal roads', '1.6 km'],
      ['Bulk services', 'Water, sewer, LV'],
      ['Award expected', 'Nov 2026'],
    ],
  },
]
